import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-blogs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './blogs.html',
  styleUrl: './blogs.css',
})
export class BlogsComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Blog',
      description: 'Product updates, guides, and notes from the orderYaa team.',
      path: '/blogs',
    });
  }
}
